import { render, staticRenderFns } from "./member-info.vue?vue&type=template&id=22e09626&scoped=true&"
import script from "./member-info.vue?vue&type=script&lang=js&"
export * from "./member-info.vue?vue&type=script&lang=js&"
import style0 from "./member-info.vue?vue&type=style&index=0&id=22e09626&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e09626",
  null
  
)

export default component.exports